import React from 'react';
import { Box, Typography, Button } from '@mui/material';

const EmptyPortfolioState = ({ onCreateAlbum, readOnly = false }) => {
  return (
    <Box sx={{ p: 0 }}>
      <Box sx={{ position: "relative", height: { xs: "280px", md: "400px" }, overflow: "hidden", borderRadius: 2 }}>
        {/* Background Image */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: 'url("/assets/images/portfolio_cover.png")',
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            zIndex: 1,
          }}
        />
        
        {/* Dark overlay */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 2,
          }}
        />
        
        {/* Centered content. Without an explicit width the absolute box grows
            to the 34px headline's natural width and spills past a phone. */}
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "100%",
            px: 2,
            boxSizing: "border-box",
            textAlign: "center",
            zIndex: 3,
          }}
        >
          <Typography
            variant="h4"
            sx={{
              fontWeight: 600,
              mb: 1,
              color: "#4D6BF6",
              fontSize: { xs: "22px", sm: "28px", md: "34px" },
            }}
          >
            Showcase your work
          </Typography>
          <Typography
            variant="h5"
            sx={{
              fontWeight: 500,
              mb: { xs: 2, md: 3 },
              color: "black",
              fontSize: { xs: "16px", sm: "20px", md: "24px" },
              letterSpacing: 0,
            }}
          >
            to attract potential clients
          </Typography>
          {!readOnly && onCreateAlbum && (
            <Button
              variant="outlined"
              onClick={onCreateAlbum}
              sx={{
                backgroundColor: "white",
                border: "1px solid #D1D5DB",
                borderRadius: 2,
                textTransform: "none",
                px: { xs: 2.5, md: 4 },
                py: 1.5,
                fontSize: { xs: "14px", md: "16px" },
                fontWeight: 600,
                color: "black",
                "&:hover": {
                  backgroundColor: "#F9FAFB",
                  border: "1px solid #D1D5DB",
                },
              }}
            >
              Upload your portfolio
            </Button>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default EmptyPortfolioState;